import DB from "./Storage";
import { firestore } from "./config";
import {
  doc,
  collection,
  getDoc,
  updateDoc,
  deleteDoc,
  addDoc,
  query,
  getDocs,
  where,
} from "firebase/firestore";

export default class Firestore {
  static addItem = async (category, price, name, description, image, id) => {
    let result = {};
    await addDoc(collection(firestore, "Products"), {
      itemId: id,
      name: name,
      price: price,
      description: description,
      category: category,
      image: image,
      timestamp: new Date().getTime(),
    })
      .then((e) => {
        result = { code: 0, val: e };
      })
      .catch((err) => {
        result = { code: 1, val: err };
      });
    return result;
  };

  static removeItem = async (itemId) => {
    let result = { code: null, itemId: null };
    const q = query(
      collection(firestore, "Products"),
      where("itemId", "==", itemId),
    );
    let snapshots = await getDocs(q);
    let id;
    snapshots.forEach((doc) => {
      id = doc.id;
    });
    await deleteDoc(doc(firestore, "Products", id))
      .then((e) => {
        result = { code: 0, val: e };
      })
      .catch((err) => {
        result = { code: 1, val: err };
      });
    return result;
  };

  updateItem = async (
    id,
    name = "",
    price = "",
    description = "",
    image = "",
  ) => {
    const ref = doc(firestore, "Products", id);
    if (name != "") {
      await updateDoc(ref, {
        name: name,
      });
    }
    if (price != "") {
      await updateDoc(ref, {
        price: price,
      });
    }
    if (description != "") {
      await updateDoc(ref, {
        description: description,
      });
    }
    if (image != "") {
      await updateDoc(ref, {
        image: image,
      });
    }
  };

  static getItem = async (itemId) => {
    let result = { code: null, val: null };
    const q = query(
      collection(firestore, "Products"),
      where("itemId", "==", itemId),
    );
    let res;
    let snapshots = await getDocs(q);
    snapshots.forEach((doc) => {
      res = doc.data();
    });
    result = { code: 0, val: res };
    return result;
  };

  static getItems = async (category) => {
    let result = { code: null, val: null };
    const q = query(
      collection(firestore, "Products"),
      where("category", "==", category),
    );
    let res = [];
    let snapshots = await getDocs(q);
    snapshots.forEach((doc) => {
      res.push(doc.data());
    });
    result = { code: 0, val: res };
    return result;
  };

  static getAllItems = async () => {
    let result = { code: null, val: null };
    const q = query(collection(firestore, "Products"));
    let res = [];
    let snapshots = await getDocs(q);
    snapshots.forEach((doc) => {
      res.push({ ...doc.data(), id: doc.id });
    });
    result = { code: 0, val: res };
    return result;
  };
}
